import { useCallback } from 'react';
import {
  getAskRecordSourceDate,
  getAskRecordSourceEntryId,
  requestTimelineEntryFocus,
} from './askRecordSourceNavigation';

const useAskRecordSourceNavigation = ({
  beforeNavigate,
  setSelectedDate,
  setTimelineFocusEntryId,
  timelineRef,
} = {}) => useCallback((source) => {
  const sourceDate = getAskRecordSourceDate(source);
  const sourceEntryId = getAskRecordSourceEntryId(source);

  if (sourceDate) {
    setSelectedDate?.(sourceDate);
  }

  beforeNavigate?.();
  requestTimelineEntryFocus(setTimelineFocusEntryId, sourceEntryId);

  window.setTimeout(() => {
    timelineRef?.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  }, 0);
}, [beforeNavigate, setSelectedDate, setTimelineFocusEntryId, timelineRef]);

export default useAskRecordSourceNavigation;
